import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./PwaUpdateBanner.module.css";

export default function PwaUpdateBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener("sw-update-available", handler);
    return () => window.removeEventListener("sw-update-available", handler);
  }, []);

  const handleUpdate = () => window.location.reload();

  if (!show) return null;

  return (
    <div className={styles.banner}>
      <span>{t("pwa.updateAvailable")}</span>
      <button className={styles.reloadBtn} onClick={handleUpdate}>
        {t("pwa.reload")}
      </button>
    </div>
  );
}
